import { graphql } from 'react-relay';

export const ChargeSelectPaymentMethod = graphql`
  mutation ChargeSelectPaymentMethodMutation(
    $input: ChargeSelectPaymentMethodInput!
  ) {
    ChargeSelectPaymentMethod(input: $input) {
      error
      charge {
        id
        paymentMethodSelected
        availablePaymentMethods
      }
    }
  }
`;
